export {default as INDEX_LATEX} from './template.js';